import styled from 'styled-components';

export const CardWrapper = styled.div`
    width: 18.875rem;
    max-height: 37.75rem;
    height: max-content;
    overflow-y: scroll;
    padding: 1rem 1.5rem;
    margin-top: 1rem;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 0.5rem;
    box-shadow: ${({ theme }) => theme.boxShadow.primary};
`;
